import React, { type ReactNode } from 'react'
import { WarningAlert } from '../../Components/WarningAlert'
import { ToggleCard } from '../../Components/ToggleCard'

export interface ContactSyncUserControlProps {
  contactSync: boolean
  syncOnDescription: ReactNode
  onChange: (enabled: boolean) => void
}

export const ContactSyncUserControl: React.FC<ContactSyncUserControlProps> = ({ contactSync, syncOnDescription, onChange }) => (
  <ToggleCard
    title='Sync contacts automatically'
    description={syncOnDescription}
    warning={
      <WarningAlert>By turning off contact synchronization, none of your contacts will be imported automatically. You can import them manually.</WarningAlert>
    }
    checked={contactSync}
    onChange={onChange}
  />
)
